import React from 'react';

interface NoActiveCycleProps {
  className?: string;
}

const NoActiveCycle: React.FC<NoActiveCycleProps> = ({ className = '' }) => {
  return (
    <div className={`min-h-[400px] flex items-center justify-center ${className}`}>
      <div className="text-center max-w-md px-6">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-6">
          <svg className="h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-3">No Active Cycle</h3>
        <p className="text-gray-600 mb-2">
          There is currently no active appraisal cycle.
        </p>
        <p className="text-sm text-gray-500">
          Please check back later or contact your administrator for more information.
        </p>
      </div>
    </div>
  );
};

export default NoActiveCycle;
